import { 
    ArrowCircle, 
    CalidadVida, 
    Clock, 
    CursoAsignado48, 
    CursoFinalizado48, 
    DB, 
    Diploma, 
    DiplomadoAsignado48, 
    DiplomadoFinalizado, 
    DiplomadoFinalizado48, 
    Finalizados, 
    HouseStar, 
    MoneyBox, 
    Sound, 
    Star, 
    TableHealth, 
    TablePlus, 
    TableStats, 
    TableWatch, 
    Wallet, 
    Water
 } from "../Constantes/SVG";
import { storageService } from "./storage_service";
import { sweetService } from "./sweet_service";
import { store } from "../app/store";
import { ROLES } from "Constantes/constants";
import { RUTAS } from "rutas";
import axios from 'axios';
import * as XLSX from "xlsx";
import dayjs from "dayjs";


export const getRandom = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

export const handleClickScroll = (id) => {
    console.log(id);
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};

export const validaDPI = (data) => {
    if (!data) {
        return true;
    }
    let cui = data.toString();
    var cuiRegExp = /^[0-9]{4}\s?[0-9]{5}\s?[0-9]{4}$/;

    if (!cuiRegExp.test(cui)) {
        return false;
    }

    cui = cui.replace(/\s/, '');
    var depto = parseInt(cui.substring(9, 11), 10);
    var muni = parseInt(cui.substring(11, 13));
    var numero = cui.substring(0, 8);
    var verificador = parseInt(cui.substring(8, 9));

    var munisPorDepto = [
      /* 01 - Guatemala tiene:      */ 17 /* municipios. */, /* 02 - El Progreso tiene:    */ 8 /* municipios. */,
      /* 03 - Sacatepéquez tiene:   */ 16 /* municipios. */, /* 04 - Chimaltenango tiene:  */ 16 /* municipios. */,
      /* 05 - Escuintla tiene:      */ 13 /* municipios. */, /* 06 - Santa Rosa tiene:     */ 14 /* municipios. */,
      /* 07 - Sololá tiene:         */ 19 /* municipios. */, /* 08 - Totonicapán tiene:    */ 8 /* municipios. */,
      /* 09 - Quetzaltenango tiene: */ 24 /* municipios. */, /* 10 - Suchitepéquez tiene:  */ 21 /* municipios. */,
      /* 11 - Retalhuleu tiene:     */ 9 /* municipios. */, /* 12 - San Marcos tiene:     */ 30 /* municipios. */,
      /* 13 - Huehuetenango tiene:  */ 32 /* municipios. */, /* 14 - Quiché tiene:         */ 21 /* municipios. */,
      /* 15 - Baja Verapaz tiene:   */ 8 /* municipios. */, /* 16 - Alta Verapaz tiene:   */ 17 /* municipios. */,
      /* 17 - Petén tiene:          */ 14 /* municipios. */, /* 18 - Izabal tiene:         */ 5 /* municipios. */,
      /* 19 - Zacapa tiene:         */ 11 /* municipios. */, /* 20 - Chiquimula tiene:     */ 11 /* municipios. */,
      /* 21 - Jalapa tiene:         */ 7 /* municipios. */, /* 22 - Jutiapa tiene:        */ 17 /* municipios. */,
    ];

    if (depto === 0 || muni === 0) {
        return false;
    }

    if (depto > munisPorDepto.length) {
        return false;
    }

    if (muni > munisPorDepto[depto - 1]) {
        return false;
    }

    var total = 0;
    for (var i = 0; i < numero.length; i++) {
        total += numero[i] * (i + 2);
    }

    var modulo = total % 11;
    return modulo === verificador;

};

export const standarSearchText = (text) => {
    return text.toLowerCase().replace('á', 'a').replace('é', 'e').replace('í', 'i').replace('ó', 'o').replace('ú', 'u');
}

export const filterTwoArrays = (arrData, arrFilter, key) => {
    return arrFilter ? arrData.filter(opt => !arrFilter.find(filter => opt[key] === filter[key])) : arrData
}

export function getBase64(url) {
    return axios
        .get(url, {
            responseType: 'arraybuffer'
        })
        .then(response => Buffer.from(response.data, 'binary').toString('base64'))
}


export const DataURIToBlob = (dataURI) => {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
}

export const getParamArchivos = (key) => {
    return storageService.getItem('urlFiles') ? storageService.getItem('urlFiles').filter(url => url.codigoParametro === key)[0].parametro : '';
}

export const dateDifferenceInDays = (dateInitial, dateFinal) =>
    (dateFinal - dateInitial) / 86_400_000;

export const addYearsToDate = (date, years) => {
    let newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() + years);

    return newDate;
}

export const cerrarSesion = (data) => {
    const timer = Number(storageService.getItem("logoutTime")) || 6000;
    const { clearTimerRef } = require("../Slices/NotificacionesUsuario/notificacionesUsuarioSlice");
    store.dispatch(clearTimerRef());

    sweetService.timerAlert(data.titulo, data.mensaje, timer)
        .then((result) => {
            console.log(result);
            if (result.isDismissed || result.isConfirmed) {
                sessionStorage.clear();

                const { resetUI } = require("../Slices/uiSlice");
                const { resetCapacitacion } = require("../Slices/Capacitacion/capacitacionSlice");
                const { resetByteState } = require("../Slices/Byte/byteSlice");
                const { resetReport } = require("../Slices/Report/reporteSlice");
                const { resetResponse } = require("../Slices/Response/responseSlice");
                const { resetDelegacion } = require("../Slices/Delegacion/delegacionSlice");
                const { resetPermisos } = require("../Slices/Permisos/permisosSlice");
                const { resetAuthUser } = require("../Slices/Login/loginSlice");

                store.dispatch(resetUI());
                store.dispatch(resetCapacitacion());
                store.dispatch(resetByteState());
                store.dispatch(resetReport());
                store.dispatch(resetResponse());
                store.dispatch(resetDelegacion());
                store.dispatch(resetPermisos());
                store.dispatch(resetAuthUser());

                storageService.removeItem('activarRenap');
                storageService.removeItem('contacto');
                storageService.removeItem('diasReporteria');
                storageService.removeItem('footer');
                storageService.removeItem('logoutTime');
                storageService.removeItem('urlFiles');
                storageService.removeItem('refreshToken');

                const [hashPath, queryString] = window.location.hash.split('?');
                if (queryString) {
                    const params = new URLSearchParams(queryString);
                    if (params.has("dpi")) {
                        params.delete("dpi");
                        window.location.hash = hashPath + (params.toString() ? `?${params.toString()}` : '');
                    }
                }

                if (storageService.getItem("user")?.idRol !== ROLES.NO_CLIENTE.ID) {
                    storageService.removeItem("user");
                    window.location.hash = RUTAS.ADMIN_LOGIN;
                }

                setTimeout(() => {
                    storageService.removeItem("user");
                    window.location.reload();
                }, 500);
            }
        });
}

export const getMaxDate = () => {
    return new Date()
}

export const checkType = (file) => {
    let valid = true
    if (file) {
        if (!['application/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
            valid = false
        }
    }
    return valid
}

export function sortByProperty(property) {
    return function (a, b) {
        if (a[property] > b[property])
            return 1;
        else if (a[property] < b[property])
            return -1;

        return 0;
    }
}


export const getSVGIcon = (icon) => {
    let svg = null;
    switch (icon) {
        case 'TableHealth':
            svg = <TableHealth />;
            break;
        case 'TablePlus':
            svg = <TablePlus />;
            break;
        case 'HouseStar':
            svg = <HouseStar />;
            break;
        case 'Water':
            svg = <Water />
            break;
        case 'DB':
            svg = <DB />;
            break;
        case 'ArrowCircle':
            svg = <ArrowCircle />;
            break;
        case 'TableStats':
            svg = <TableStats />;
            break;
        case 'TableWatch':
            svg = <TableWatch />;
            break;
        case 'Phone':
            svg = <TableHealth />;
            break;
        case 'Money':
            svg = <TableHealth />;
            break;
        case 'Refresh':
            svg = <TableHealth />;
            break;
        case 'TableQuestion':
            svg = <TableHealth />;
            break;
        case 'MoneyBox':
            svg = <MoneyBox />;
            break;
        case 'Wallet':
            svg = <Wallet />;
            break;
        case 'Star':
            svg = <Star />
            break;
        case 'Finalizados':
            svg = <Finalizados />
            break;
        case 'Diploma':
            svg = <Diploma />
            break;
        case 'DiplomadoFinalizado':
            svg = <DiplomadoFinalizado />
            break;
        case 'calidadVida':
            svg = <CalidadVida />
            break;
        case 'DiplomadoFinalizado48':
            svg = <DiplomadoFinalizado48 />
            break;
        case 'DiplomadoAsignado48':
            svg = <DiplomadoAsignado48 />
            break;
        case 'DiplomadoAsignado':
            svg = <Diploma />
            break;
        case 'CursoFinalizado48':
            svg = <CursoFinalizado48 />
            break;
        case 'CursoFinalizado':
            svg = <Finalizados />
            break;
        case 'CursoAsignado48':
            svg = <CursoAsignado48 />
            break;
        case 'CursoAsignado':
            svg = <Star />
            break;
        case 'Clock':
            svg = <Clock />
            break;
        case 'Sound':
            svg = <Sound />
            break;
        default:
            break;
    }
    return svg;
}

export const getComponent = (file) => {
    let extension = file.split('.').pop();
    console.log(extension);
}

export const getLastOrder = (arr) => {
    const lastOrden = arr?.length > 0 ? arr[arr.length - 1]?.orden + 1 : 1;
    return lastOrden;
}

export const getFormattedTime = (date) => {
    if (date) {
        const options = { hour: '2-digit', minute: '2-digit' };
        return date.toLocaleTimeString('es-ES', options);
    }
}

export const forzarSaltos = (texto) => {
    try {
        if (texto.includes('\\r\\n')) {
            texto = JSON.parse(`"${texto}"`);
        }
    } catch { }
    return texto.replace(/\r\n/g, '\n');
};

export function exportExcelPaginated(data = [], pageSize = 10000, filename = "export.xlsx") {
    if (!Array.isArray(data) || data.length === 0) {
        console.warn("No hay datos para exportar.");
        return;
    }

    const wb = XLSX.utils.book_new();
    const totalPages = Math.ceil(data.length / pageSize);

    for (let i = 0; i < totalPages; i++) {
        const start = i * pageSize;
        const end = start + pageSize;
        const pageData = data.slice(start, end);

        const sheet = XLSX.utils.json_to_sheet(pageData);
        XLSX.utils.book_append_sheet(wb, sheet, `Página ${i + 1}`);
    }

    XLSX.writeFile(wb, filename);
}

export const getParamValue = (data, codigo, campo, salida) => {
    if (!data || !Array.isArray(data)) return null;
    const param = data.find((p) => p[campo] === codigo);
    return param?.[salida] || null;
};

export const toggleColumns = (cols, { show = [], hide = [] } = {}) =>
    cols.map(c => {
        if (hide.includes(c.name)) return { ...c, options: { ...c.options, display: false } };
        if (show.includes(c.name)) return { ...c, options: { ...c.options, display: true } };
        return c;
    });

export const formatFechaGT = (fechaStr, longDate = false) => {
    if (!fechaStr) return "";

    const d = dayjs(fechaStr, "YYYY-MM-DD HH:mm:ss", true);
    if (!d.isValid()) return fechaStr;

    return longDate ? d.format("DD [de] MMMM [de] YYYY [a las] HH:mm") : d.format("DD/MM/YYYY HH:mm");
};

export const mapColumnaFromApi = (col) => {
    const renderMap = {
        ROW_INDEX: (_, tableMeta) => tableMeta.rowIndex + 1,
        DATE:      (v) => new Date(v).toLocaleDateString(),
        TIME:      (v) => new Date(v).toLocaleTimeString(),
        FIXED:     () => col.valor,
    };

    return {
        name: col.referencia,
        label: col.etiqueta,
        options: {
            filter: col.tipo !== 'ROW_INDEX',
            sort: true,
            display: col.visible,
            setCellHeaderProps: () => ({ align: col.estilo }),
            setCellProps: () => ({ align: col.estilo }),
            ...(renderMap[col.tipo] && { customBodyRender: renderMap[col.tipo] }),
        }
    };
};
